module.exports = __webpack_public_path__ + "static/media/happy.ebeddc25.png";